import { Suspense } from 'react';
import ProjectEditForm from './Forms/ProjectEditForm';
import { MainContainer } from '../MainDashboard/StyledComponents';

const ProjectEditWithSuspense = () => (
  <MainContainer sx={{ width: '100%' }}>
    <Suspense fallback={<div>Loading...</div>}>
      <input type="hidden" value="default" />
      <ProjectEditForm />
    </Suspense>
  </MainContainer>
);
export default ProjectEditWithSuspense;
